import { Route } from "react-router-dom";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureRoute from "@/components/FeatureRoute";

const GrilleTamponPage = lazy(() => import("@/pages/stock/GrilleTamponPage"));
const ServeurLayout = lazy(() => import("@/pages/pos/serveur/ServeurLayout"));
const ServeurPlanSallePage = lazy(() => import("@/pages/pos/serveur/ServeurPlanSallePage"));
const PriseCommandePage = lazy(() => import("@/pages/pos/serveur/PriseCommandePage"));
const MesCommandesPage = lazy(() => import("@/pages/pos/serveur/MesCommandesPage"));
const EnvoiConfirmationPage = lazy(() => import("@/pages/pos/serveur/EnvoiConfirmationPage"));
const KdsLayout = lazy(() => import("@/pages/pos/kds/KdsLayout"));
const KdsCuisinePage = lazy(() => import("@/pages/pos/kds/KdsCuisinePage"));
const KdsBarPage = lazy(() => import("@/pages/pos/kds/KdsBarPage"));
const KdsOrderDetailPage = lazy(() => import("@/pages/pos/kds/KdsOrderDetailPage"));
const CaisseLayout = lazy(() => import("@/pages/pos/caisse/CaisseLayout"));
const CaissePlanSallePage = lazy(() => import("@/pages/pos/caisse/CaissePlanSallePage"));
const CaisseVenteComptoirPage = lazy(() => import("@/pages/pos/caisse/VenteComptoirPage"));
const CaisseNotePage = lazy(() => import("@/pages/pos/caisse/NotePage"));
const CaisseEncaissementPage = lazy(() => import("@/pages/pos/caisse/EncaissementPage"));
const CaisseSplitPage = lazy(() => import("@/pages/pos/caisse/SplitAdditionPage"));
const CaisseMembrePage = lazy(() => import("@/pages/pos/caisse/MembreSelectPage"));
const CaisseHistoriquePage = lazy(() => import("@/pages/pos/caisse/HistoriqueTicketsPage"));
const CaisseTicketPage = lazy(() => import("@/pages/pos/caisse/TicketDetailPage"));
const CaisseRapportXPage = lazy(() => import("@/pages/pos/caisse/RapportXPage"));
const CaisseRapportZPage = lazy(() => import("@/pages/pos/caisse/RapportZPage"));
const CaisseJournalPage = lazy(() => import("@/pages/pos/caisse/JournalPage"));

export function posRoutes() {
  return (
    <>
      {/* Grille tampon : pleine page sans sidebar (interface tactile) */}
      <Route
        path="/stock/grille-tampon"
        element={
          <ProtectedRoute>
            <GrilleTamponPage />
          </ProtectedRoute>
        }
      />

      {/* Mode serveur */}
      <Route
        element={
          <ProtectedRoute allowedRoles={["serveur", "chef_salle", "gerante", "admin"]}>
            <FeatureRoute flag="pos.commandes">
              <ServeurLayout />
            </FeatureRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/serveur" element={<ServeurPlanSallePage />} />
        <Route path="/serveur/mes-commandes" element={<MesCommandesPage />} />
        <Route path="/serveur/commande/:orderId" element={<PriseCommandePage />} />
        <Route path="/serveur/commande/:orderId/envoye" element={<EnvoiConfirmationPage />} />
      </Route>

      {/* KDS */}
      <Route
        element={
          <ProtectedRoute allowedRoles={["cuisinier", "barman", "gerante", "admin"]}>
            <FeatureRoute flag="pos.kds">
              <KdsLayout />
            </FeatureRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/kds/cuisine" element={<KdsCuisinePage />} />
        <Route path="/kds/bar" element={<KdsBarPage />} />
        <Route path="/kds/commande/:orderId" element={<KdsOrderDetailPage />} />
      </Route>

      {/* Caisse / encaissement */}
      <Route
        element={
          <ProtectedRoute allowedRoles={["caissiere", "gerante", "admin", "pdg"]}>
            <FeatureRoute flag="pos.encaissement">
              <CaisseLayout />
            </FeatureRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/caisse" element={<CaissePlanSallePage />} />
        <Route path="/caisse/vente-comptoir" element={<CaisseVenteComptoirPage />} />
        <Route path="/caisse/note/:orderId" element={<CaisseNotePage />} />
        <Route path="/caisse/note/:orderId/encaisser" element={<CaisseEncaissementPage />} />
        <Route path="/caisse/note/:orderId/split" element={<CaisseSplitPage />} />
        <Route path="/caisse/membre/:orderId" element={<CaisseMembrePage />} />
        <Route path="/caisse/historique" element={<CaisseHistoriquePage />} />
        <Route path="/caisse/ticket/:paymentId" element={<CaisseTicketPage />} />
        <Route
          path="/caisse/rapport-x"
          element={<FeatureRoute flag="caisse.journaux"><CaisseRapportXPage /></FeatureRoute>}
        />
        <Route
          path="/caisse/rapport-z"
          element={<FeatureRoute flag="caisse.journaux"><CaisseRapportZPage /></FeatureRoute>}
        />
        <Route
          path="/caisse/journal/offerts"
          element={<FeatureRoute flag="caisse.journaux"><CaisseJournalPage variant="offert" /></FeatureRoute>}
        />
        <Route
          path="/caisse/journal/annulations"
          element={<FeatureRoute flag="caisse.journaux"><CaisseJournalPage variant="annulation" /></FeatureRoute>}
        />
        <Route
          path="/caisse/journal/duplicatas"
          element={<FeatureRoute flag="caisse.journaux"><CaisseJournalPage variant="duplicata" /></FeatureRoute>}
        />
      </Route>
    </>
  );
}
